import { computed, onMounted, ref, unref } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

const filenameFrom = response => {
  const disposition = response?.headers?.['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || 'Recibo_de_Sinal.docx';
};

export function useSalesReceiptDraft({ id, t, notify }) {
  const draft = ref(null);
  const loading = ref(false);
  const downloading = ref(false);
  const error = ref('');
  const unavailable = ref(false);
  const accepted = ref(true);

  const load = async () => {
    if (!unref(id)) return null;

    loading.value = true;
    error.value = '';
    unavailable.value = false;
    try {
      const response = await SalesTransactionsAPI.receiptDraft(unref(id));
      draft.value = response?.data || null;
      return draft.value;
    } catch (requestError) {
      unavailable.value = [403, 409, 422].includes(
        requestError?.response?.status
      );
      error.value =
        requestError?.response?.data?.message ||
        requestError?.response?.data?.error ||
        t('SALES.RECEIPT_DRAFT.ERROR');
      if (!unavailable.value) notify(error.value);
      return null;
    } finally {
      loading.value = false;
    }
  };

  const download = async () => {
    if (!accepted.value || downloading.value || !unref(id)) return false;

    downloading.value = true;
    try {
      const response = await SalesTransactionsAPI.downloadReceiptDraft(
        unref(id)
      );
      const blob = response?.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filenameFrom(response);
      link.click();
      window.URL.revokeObjectURL(url);
      await load();
      return true;
    } catch (requestError) {
      notify(
        requestError?.response?.data?.message ||
          requestError?.response?.data?.error ||
          t('SALES.RECEIPT_DRAFT.ERROR')
      );
      return false;
    } finally {
      downloading.value = false;
    }
  };

  const lastDownload = computed(() => draft.value?.last_download_at || '');
  onMounted(load);

  return {
    accepted,
    draft,
    downloading,
    error,
    lastDownload,
    load,
    loading,
    unavailable,
    download,
  };
}
